import React, { useContext, useState } from 'react'
import { useMutation } from '@apollo/client'
import { Button, Dropdown, MenuProps, message } from 'antd'
import styled from 'styled-components'
import { LEGAL_NOTICE_EXPORT_MUTATION } from 'graphql/LegalNoticesExports'
import { VariablesContext } from '../contexts/variablesContext'

type MenuItem = Required<MenuProps>['items'][number]

interface Props {
  tableLoading: boolean
  providerKey: string
}

const LegalNoticesActionsMenu = ({
  tableLoading,
  providerKey,
}: Props): JSX.Element => {
  const { apiParameters } = useContext(VariablesContext)
  const [loading, setLoading] = useState(false)
  const [exportNotices] = useMutation(LEGAL_NOTICE_EXPORT_MUTATION)
  const [messageApi, contextHolder] = message.useMessage()

  const handleExport = () => {
    const { filters, search } = apiParameters()
    setLoading(true)
    exportNotices({
      variables: { provider: providerKey, filters, search },
    })
      .then(res => {
        setLoading(false)
        const msg = res.data?.legalNoticeExport?.message
        if (msg) messageApi.open({ type: 'success', content: msg, duration: 4 })
      })
      .catch(err => {
        setLoading(false)
        messageApi.open({ type: 'error', content: err.message })
      })
  }

  const items: MenuItem[] = [
    {
      key: 'exports',
      icon: <i className="fa fa-file" />,
      label: 'Exports',
      children: [
        {
          key: 'csv',
          label: 'Exporter en CSV (résultats filtrés)',
          onClick: handleExport,
        },
      ],
    },
  ]

  return (
    <MenuWrapper>
      {contextHolder}
      <Dropdown menu={{ items }} disabled={tableLoading}>
        <MenuButton>
          {loading ? (
            <i className="fa fa-spinner" />
          ) : (
            <i className="fa fa-cogs" />
          )}
        </MenuButton>
      </Dropdown>
    </MenuWrapper>
  )
}

export default LegalNoticesActionsMenu

const MenuButton = styled(Button)`
  height: fit-content;
  background: white;
  color: rgba(0, 0, 0, 0.45);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 4px 10px;
  i {
    padding: 10px 0;
    margin: 0;
  }
`

const MenuWrapper = styled.div`
  padding: 20px 0 8px;
  display: flex;
`
